module.exports = __webpack_public_path__ + "phone-solid.svg?b8feaf97dc671d1f027c7a5ff8df3e54";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-solid.svg
// module id = 180
// module chunks = 0